module.exports = __webpack_public_path__ + "img/splash.d5facec8.png";